import { BowlCollection, isRole, isTenant, roles } from '@websolutespa/payload-plugin-bowl';
import { options } from '../options';

export const LlmHistory: BowlCollection = {
  type: 'withCollection',
  slug: options.slug.llmHistory,
  admin: {
    group: options.group.llm,
    defaultColumns: ['id', 'createdAt', 'llmApp'],
  },
  access: {
    create: (args) => false,
    read: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmThread)(args),
    update: (args) => false,
    delete: (args) => isRole(roles.Admin)(args),
  },
  fields: [
    {
      name: 'llmApp',
      type: 'relationship',
      relationTo: options.slug.llmApp,
      required: true,
    },
    {
      name: 'userId',
      type: 'text',
      required: true,
    },
    {
      name: 'llmThread',
      type: 'relationship',
      relationTo: options.slug.llmThread,
      required: true,
    },
    {
      name: 'messageId',
      type: 'text',
      required: true,
    },
  ],
};

